// src/components/common/CommonPopup.jsx
import React from "react";

// Optional: Import all your popup images (you can move to public/ if preferred)
import addResidentImg from "../../assets/images/user-add-fill.png";
import parcelPendingImg from "../../assets/images/parcel_pending.png";
import successImg from "../../assets/images/success_check.png";
import errorImg from "../../assets/images/cannot_add.png";
import sessionActiveImg from "../../assets/images/session_active.png";

const CommonPopup = ({
  isOpen,
  onClose,
  title,
  message,
  image, // Direct image (priority)
  imageType, // Auto-select image by type: "add", "pending", "success", "error", "session"
  primaryText = "Yes",
  secondaryText = "No",
  onPrimary,
  onSecondary,
  singleButton = false,
  singleButtonText = "Okay",
  singleButtonColor = "green", // "green" or "red"
}) => {
  if (!isOpen) return null;

  // Auto pick image based on type if not passed directly
  const getImageByType = () => {
    if (image) return image;
    if (!imageType) return successImg;

    const map = {
      add: addResidentImg,
      pending: parcelPendingImg,
      success: successImg,
      error: errorImg,
      session: sessionActiveImg,
    };
    return map[imageType] || successImg;
  };

  const popupImage = getImageByType();

  // Auto title color
  const titleColor = () => {
    if (title.toLowerCase().includes("success")) return "text-green-600";
    if (
      title.toLowerCase().includes("pending") ||
      title.toLowerCase().includes("parcel")
    )
      return "text-orange-600";
    if (
      title.toLowerCase().includes("error") ||
      title.toLowerCase().includes("can't") ||
      title.toLowerCase().includes("session")
    )
      return "text-red-600";
    return "text-gray-900";
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-sm overflow-hidden">
        {/* Title */}
        <h2
          className={`text-center text-2xl font-bold pt-8 px-8 ${titleColor()}`}
        >
          {title}
        </h2>

        {/* Image After Title */}
        <div className="flex justify-center my-6">
          <img
            src={popupImage}
            alt="popup"
            className="w-24 h-24 object-contain"
          />
        </div>

        {/* Message */}
        <p className="text-center text-gray-700 text-lg px-8 mb-10 leading-relaxed">
          {message}
        </p>

        {/* Buttons */}
        <div className="px-8 pb-10">
          {singleButton ? (
            <button
              onClick={onPrimary || onClose}
              className={`w-full py-3 text-white font-bold rounded-full text-lg shadow-md transition ${
                singleButtonColor === "red"
                  ? "bg-red-500 hover:bg-red-600"
                  : "bg-green-500 hover:bg-green-600"
              }`}
            >
              {singleButtonText}
            </button>
          ) : (
            <div className="flex gap-4">
              <button
                onClick={onSecondary || onClose}
                className="flex-1 py-3 bg-red-500 hover:bg-red-600 text-white font-bold rounded-full text-lg shadow-md transition"
              >
                {secondaryText}
              </button>
              <button
                onClick={onPrimary || onClose}
                className="flex-1 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-full text-lg shadow-md transition"
              >
                {primaryText}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CommonPopup;
